var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardsBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "wallet-minus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.021,0H0",
    transform: "translate(10.714 18.664)",
    fill: "none",
    stroke: "#1e153f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M9.273.624,9.237.708l-3.492,8.1H2.312A5.919,5.919,0,0,0,0,9.283L2.107,4.249l.048-.12.084-.193a1.042,1.042,0,0,1,.084-.2C3.9.082,5.684-.749,9.273.624Z",
    transform: "translate(5.699 2.409)",
    fill: "none",
    stroke: "#1e153f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M10.019,8.43a5.732,5.732,0,0,0-1.7-.241H0L3.492.084,3.528,0c.181.06.349.145.53.217L6.72,1.337A7.824,7.824,0,0,1,9.863,3.36a2.547,2.547,0,0,1,.3.434,1.832,1.832,0,0,1,.241.518,1.944,1.944,0,0,1,.108.313A5.694,5.694,0,0,1,10.019,8.43Z",
    transform: "translate(11.138 3.032)",
    fill: "none",
    stroke: "#1e153f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M22.593,5.877V8.225c0,.241-.012.482-.023.723-.22,4.2-2.478,6.322-6.763,6.322H6.774a6.15,6.15,0,0,1-.822-.06Q.428,14.831.058,9.08A6.907,6.907,0,0,1,0,8.225V5.877A5.9,5.9,0,0,1,3.428.47,5.545,5.545,0,0,1,5.651,0h11.3a5.589,5.589,0,0,1,1.633.241A5.881,5.881,0,0,1,22.593,5.877Z",
    transform: "translate(2.423 10.319)",
    fill: "none",
    stroke: "#1e153f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M5.672,0,3.565,5.034A5.893,5.893,0,0,0,0,10.441V6.912A7.043,7.043,0,0,1,5.672,0Z",
    transform: "translate(2.409 6.332)",
    fill: "none",
    stroke: "#1e153f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M4.167,6.226V9.755A5.875,5.875,0,0,0,0,4.131,5.9,5.9,0,0,0,.506.313,1.376,1.376,0,0,0,.4,0,7.012,7.012,0,0,1,4.167,6.226Z",
    transform: "translate(20.845 6.997)",
    fill: "none",
    stroke: "#1e153f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-7",
    "data-name": "Vector",
    d: "M0,0H28V28H0Z",
    fill: "none",
    opacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardsBlack);
export default __webpack_public_path__ + "static/media/cardsBlack.772910c557af002ac593bb8f30debc3b.svg";
export { ForwardRef as ReactComponent };